module.exports = __webpack_public_path__ + "static/media/hourglass-half.a9032593.svg";